import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';

import PropResiCreate_Dwk from '../dwk/propertyResi/PropResiCreate'
import PropComCreate_Dwk from '../dwk/propertyCom/PropComCreate'

import PropResiCreate_Ggn from '../gurgaon/propertyResi/PropResiCreate'
import PropComCreate_Ggn from '../gurgaon/propertyCom/PropComCreate'
import { closeModal } from '../../actions/modalAction';

const actions = { closeModal };

class ShowImageModal extends Component {
  render() {
    
    return (
      <Modal 
      className='min-max-width'
      //size="tiny" 
      open={true} 
      onClose={this.props.closeModal}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      basic
      >
       
        <Modal.Content>
        {this.props.propresi_Dwk && <PropResiCreate_Dwk/>}
        {this.props.propcom_Dwk && <PropComCreate_Dwk/>}
        {this.props.propresi_Ggn && <PropResiCreate_Ggn/>}
        {this.props.propcom_Ggn && <PropComCreate_Ggn/>}
        </Modal.Content>
      </Modal>
    );
  }
}

export default connect(
  null,
  actions
)(ShowImageModal);
